import * as React from 'react';
import './vertical-spacing.scss';

type Props = {
  type: 'tiny' | 'small' | 'medium' | 'large' | 'xlarge'
};

const VerticalSpacing = (
  {
    type
  }: Props
): JSX.Element => <div className={`vertical-spacing--${type || 'small'}`} />;

export default VerticalSpacing;
